
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setHasDoors = (hasDoors: libTypes.Order['hasDoors']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.hasDoors = fns.order.set.hasDoors(hasDoors);
        })
    });
};